import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `BreadcrumbItemDirective` represent a item of the React Breadcrumb.
 * It must be contained in a Breadcrumb component(`BreadcrumbComponent`).
 * ```tsx
 * <BreadcrumbComponent>
 *   <BreadcrumbItemsDirective>
 *    <BreadcrumbItemDirective text='Home' url='/'></BreadcrumbItemDirective>
 *    <BreadcrumbItemDirective text='Index' url='./index'></BreadcrumbItemDirective>
 *   </BreadcrumbItemsDirective>
 * </BreadcrumbComponent>
 * ```
 */
export class BreadcrumbItemDirective extends ComplexBase {
}
BreadcrumbItemDirective.moduleName = 'breadcrumbItem';
export class BreadcrumbItemsDirective extends ComplexBase {
}
BreadcrumbItemsDirective.propertyName = 'items';
BreadcrumbItemsDirective.moduleName = 'breadcrumbItems';
